import Swiper from "swiper";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import {limitSwiperPagination, resolveSliderLayout} from "../../../../eila-global/js/slider/sliderHelpers.js";

export function initGallery(wrapper = document) {

    for(let imageGallery of wrapper.querySelectorAll('.imageGalleryEila')) {
        const instance = imageGallery?.swiper;

        if (instance) {
            instance.destroy(true, true);
        }
        try {
            Swiper.use([Autoplay, Navigation, Pagination]);
            const swiper = new Swiper(imageGallery, resolveSliderLayout(imageGallery, {
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 2,
                spaceBetween: 0,
                loop: true,
                slideToClickedSlide: true,
                initialSlide: 0,
                autoplay: {
                    delay: 5000
                },
                pagination: {
                    el: imageGallery.querySelector(".swiper-pagination"),
                },
                navigation: {
                    nextEl: imageGallery.querySelector('.swiper-button-next'),
                    prevEl: imageGallery.querySelector('.swiper-button-prev'),
                    addIcons: false
                },
            }));

            limitSwiperPagination(swiper);

            imageGallery.addEventListener('mouseenter', () => {
                swiper.autoplay.stop();
            });

            imageGallery.addEventListener('mouseleave', () => {
                swiper.autoplay.start();
            });
        } catch (error) {
            console.error('Error initializing Swiper:', error);
        }
    }

}
